export default class EventListener {
    constructor($rootScope, $state, $timeout, $filter, Tag, Events, Automation, Event) {
        this._rootScope = $rootScope;
        this._state = $state;
        this._timeout = $timeout;
        this._filter = $filter;
        this.tagRepo = Tag;
        this.automationRepo = Automation;
        this.eventRepo = Event;
        this.events = Events;
    }

    setScope(g_scope) {
        this._scope = g_scope;
    };

    handleRootEvents() {
        this._rootScope.$on('campaign:newSMS', () => {
            this._state.go('campaign.create', { type: 'text_message' });
        });

        this._rootScope.$on('campaign:newEmail', () => {
            this._state.go('campaign.create', { type: 'email' });
        });

        this._rootScope.$on('tag:newTag', () => {
            this.tagRepo.store("New").then((tag) => {
                this._state.go('tag.show', { id: tag.data.id });
                var notification = this._filter('translate')('TAG:FLASH:CREATE_EXPLAINED').replace(/:name/, tag.data.name);
                this.events.flashEvent('notification', notification);
            }, (results) => {
                if (results.error = 'DuplicateTag') {
                    this.events.flashEvent('error', this._filter('translate')('TAG:FLASH:DUPLICATE_EXPLAINED'));
                } else {
                    this.events.flashEvent('error', this._filter('translate')('TAG:FLASH:CREATE_ERROR'));
                }
            })
        });

        this._rootScope.$on('automation:newAutomation', () => {
            if (this._state.current.name != 'automation.index' && this._state.current.name != 'automation.folder') {
                this.automationRepo.store().then(() => {
                    this.events.flashEvent('notification', this._filter('translate')('AUTOMATION:FLASH:AUTOMATION_CREATED'));
                    this._state.go('automation.index');
                });
            }
        });

        this._rootScope.$on('event:newEvent', () => {
            this.eventRepo.searchByStatus('all').then(response => {
                let allEventsNames = response.data.map(event => event.name);
                let newEventName = this._filter('getNumberedName')(allEventsNames, 'New');
                return this.eventRepo.create(newEventName).then((response) => {
                    this._state.go('event.index');

                    this._timeout(() => {
                        this._rootScope.$emit('event:newEventCreated', response.data);
                    });
                });
            }).catch(error => {
                let errorMessage = this._filter('translate')('GLOBAL:ERROR:DEFAULT');
                if (error.data && error.data.code === 9) {
                    errorMessage = error.data.message || errorMessage;
                }
                this.events.flashEvent('error', errorMessage);
            });
        });
    };

    handleScopedEvents() {
       this._scope.$on('$stateChangeSuccess', () => {
            this._scope.menuShow = false; // Hide dropDownMenu when state changes, better naming needed
            this._scope.settingsMenuShow = false;
        });

        this._scope.$on('event:auth.loginRequired', () => {
            this._scope.loginRequired = true;
        });

        this._scope.$on('event:auth.loginFailed', () => {
            // No action at the moment..
        });
    };
}
